import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";
import { SPACING } from "@/design-system";

interface DocumentContentSkeletonProps {
  className?: string;
  lineCount?: number;
}

export function DocumentContentSkeleton({ className, lineCount = 5 }: DocumentContentSkeletonProps) {
  // Varying widths for natural text appearance
  const widths = ["w-full", "w-3/4", "w-5/6", "w-full", "w-2/3", "w-4/5", "w-full", "w-3/5"];
  
  return (
    <div className={cn(SPACING.contentContainer, className)}>
      {[...Array(lineCount)].map((_, i) => (
        <Skeleton key={i} className={cn("h-4", widths[i % widths.length])} />
      ))}
    </div>
  );
}
